export const log_columns = [
  {
    id: 'homebase',
    label: 'Homebase',
    minWidth: 220,
    hide: [],
    align: 'left',
  },
  {
    id: 'missing',
    label: 'Missing',
    minWidth: 200,
    hide: [],
    warning: (value) => {
      return !value || value === '-' ? false : true
    },
    align: 'left',
  },
  {
    id: 'assetTrackers',
    label: 'Asset trackers',
    minWidth: 210,
    hide: [],
    align: 'left',
  },
  {
    id: 'battery',
    label: 'Battery',
    minWidth: 120,
    hide: [],
    align: 'left',
  },
]
